import { Card, Checkbox, Badge, Button } from '@aimsos/ui';
import { Settings, Trash2 } from 'lucide-react';

const ToolCard = ({
  t,
  title,
  description,
  isEnabled = false,
  onToggle,
  onSettings,
  onDelete,
  toolData,
  requiresSetup = false,
}) => (
  <Card className="w-full">
    <Card.Body className="flex flex-row items-center gap-3 py-4">
      <div
        className={`min-w-0 flex-1 ${requiresSetup ? 'opacity-60 grayscale-[0.3]' : ''}`}
      >
        <div className="mb-1 flex flex-wrap items-center gap-2">
          <h3 className="text-base font-semibold text-content">{title}</h3>
          {requiresSetup && (
            <Badge variant="alert" size="small" className="shrink-0">
              {t('edit.tools.setupRequired')}
            </Badge>
          )}
        </div>
        <p className="text-sm text-content-muted">{description}</p>
      </div>
      <div className="flex shrink-0 items-center gap-3">
        <Checkbox
          checked={isEnabled}
          onChange={onToggle}
          size="small"
          disabled={requiresSetup}
          aria-label={isEnabled ? t('edit.tools.disable', { title }) : t('edit.tools.enable', { title })}
        />
        <Button
          type="button"
          variant="secondary"
          size="sm"
          leftIcon={Settings}
          className="!h-9 !w-9 !min-w-0 !p-0"
          onClick={() => onSettings(toolData)}
          aria-label={t('edit.tools.settings', { title })}
        />
        <Button
          type="button"
          variant="secondary"
          size="sm"
          leftIcon={Trash2}
          className="!h-9 !w-9 !min-w-0 !p-0"
          onClick={onDelete}
          aria-label={t('edit.tools.remove', { title })}
        />
      </div>
    </Card.Body>
  </Card>
);

export default ToolCard;
